import { gsap, ScrollTrigger } from 'gsap/all';
import SplitText from "../__vendor/SplitText.min.js";


gsap.registerPlugin(ScrollTrigger);

const contactSection = () => {
    const contactSectionTl = gsap.timeline({
        paused: true
    });

    const text = new SplitText(".hero-contact h1 , .contact-info h4, .contact-info label", { type: "lines" });

    gsap.set(".hero-contact h1 > div, .contact-info h4 > div, .contact-info label > div, .contact-info input, .contact-info textarea, .contact-info a , .contact-info ul li, .contact-info button", {
        opacity: 0,
        y: 15
    });


    contactSectionTl.set('.hero-contact', {
        className: "+=hero-contact active",
    }, 0.5).to(text.lines, {
        autoAlpha: 1,
        y: 0,
        stagger: 0.085,
    }, 0.7).to('.contact-info input, .contact-info textarea, .contact-info a, .contact-info ul li, .contact-info button', {
        autoAlpha: 1,
        y: 0,
        stagger: 0.085,
    }, 0.7)

    ScrollTrigger.create({
        scroller:'[data-scroll-container]',
        trigger: '.hero-contact',
        start: 'top bottom-=200',
        end: 'bottom top',
        animation: contactSectionTl,
        toggleActions: 'play none none none',
    });
};

export default contactSection;